// client/src/components/Auth/GoogleLoginButton.js
import React from 'react';
import { Button } from '@mui/material';
import { Google as GoogleIcon } from '@mui/icons-material';
import { Capacitor } from '@capacitor/core';

const GoogleLoginButton = ({ variant = 'outlined', fullWidth = true, size = 'large' }) => {
    const handleGoogleLogin = () => {
        // Construct OAuth URL based on environment
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
        
        // Determine base URL for OAuth redirect
        let oauthUrl;
        if (apiBaseUrl.startsWith('http://') || apiBaseUrl.startsWith('https://')) {
            // Full URL provided (production mode)
            oauthUrl = apiBaseUrl.replace(/\/api$/, '') + '/api/auth/google';
        } else {
            // Proxy mode (development) - use relative URL
            oauthUrl = '/api/auth/google';
        }
        
        // On native mobile: open in the system browser (Chrome Custom Tab) so
        // Google OAuth works correctly and the deep-link callback can return to
        // the app. The state=mobile flag in the URL is enough for the backend to
        // know it should redirect to com.soldikeeper.app://oauth/success.
        if (Capacitor.isNativePlatform()) {
            oauthUrl += '?source=mobile';
            window.open(oauthUrl, '_blank', 'location=yes');
            return;
        }

        // Web: navigate directly
        window.location.href = oauthUrl;
    };

    return (
        <Button
            variant={variant}
            fullWidth={fullWidth}
            size={size}
            onClick={handleGoogleLogin}
            startIcon={<GoogleIcon />}
            sx={{
                borderColor: '#dadce0',
                color: '#3c4043',
                fontSize: '14px',
                fontWeight: 500,
                textTransform: 'none',
                '&:hover': {
                    backgroundColor: '#f8f9fa',
                    borderColor: '#dadce0',
                }
            }}
        >
            Continue with Google
        </Button>
    );
};

export default GoogleLoginButton;
